// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family: "Montserrat", sans-serif;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Button {
  color: white;
  background-color: blue;
  padding: 10px;
  width: 100px;
  font-weight: 800;
  letter-spacing: 2;
  cursor: pointer;
  border-radius: 10px;
  transform: all 1s cubic-bezier(0.42, 0, 0.17, 0.71);
  margin: 10px;
}

.Button:hover {
  background-color: red;
}

.dialog {
  padding: 20px;
  background: white;
  position: absolute;
  z-index: 500;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(37, 37, 37, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  background-color: white;
  margin: 0;
  width: 400px;
  height: 400px;
  display: flex;
  padding: 20px;
  flex-direction: column;
  border-radius: 10px;
  align-items: flex-start;
  justify-content: space-between;
  overflow-y: auto;
}

.close {
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
  display: flex;
}

.close > button {
  height: 36px;
  width: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.title {
  font-weight: 700;
  font-size: 1.5rem;
  margin: 0;
  padding-bottom: 5px;
}

@keyframes anime {
  0% {
    font-size: 10px;
  }
  30% {
    font-size: 15px;
  }
  100% {
    font-size: 12px;
  }
}

.detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: 0;
  height: 40px;
  border-bottom: 1px dashed;
  animation:slidein 2s;
}
.detail-first-child {
  border-top: 1px dashed;
  margin-top: 20px;
}

.detail-header {
  font-weight: bold;
  font-size: 1rem;
}

.detail-content {
  font-size: 1rem;
  padding-left: 5px;
}

.green {
  color: rgb(153, 255, 0);
}
.description {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: fit-content;
}
.red {
  color: red;
}

.message {
  font-size: 0.8rem;
}
.small {
  font-size: 0.9rem;
}


@keyframes slidein {
  from {
    margin-left: 100%;
    width: 300%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}

.errorMessage{
  display: flex;
  align-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;;AAGA;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat&display=swap\");\n\n.App {\n  font-family: \"Montserrat\", sans-serif;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.Button {\n  color: white;\n  background-color: blue;\n  padding: 10px;\n  width: 100px;\n  font-weight: 800;\n  letter-spacing: 2;\n  cursor: pointer;\n  border-radius: 10px;\n  transform: all 1s cubic-bezier(0.42, 0, 0.17, 0.71);\n  margin: 10px;\n}\n\n.Button:hover {\n  background-color: red;\n}\n\n.dialog {\n  padding: 20px;\n  background: white;\n  position: absolute;\n  z-index: 500;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(37, 37, 37, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dialog-content {\n  background-color: white;\n  margin: 0;\n  width: 400px;\n  height: 400px;\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  border-radius: 10px;\n  align-items: flex-start;\n  justify-content: space-between;\n  overflow-y: auto;\n}\n\n.close {\n  width: 100%;\n  align-items: flex-end;\n  justify-content: flex-end;\n  display: flex;\n}\n\n.close > button {\n  height: 36px;\n  width: 36px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.title {\n  font-weight: 700;\n  font-size: 1.5rem;\n  margin: 0;\n  padding-bottom: 5px;\n}\n\n@keyframes anime {\n  0% {\n    font-size: 10px;\n  }\n  30% {\n    font-size: 15px;\n  }\n  100% {\n    font-size: 12px;\n  }\n}\n\n.detail {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  height: 40px;\n  border-bottom: 1px dashed;\n  animation:slidein 2s;\n}\n.detail-first-child {\n  border-top: 1px dashed;\n  margin-top: 20px;\n}\n\n.detail-header {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.detail-content {\n  font-size: 1rem;\n  padding-left: 5px;\n}\n\n.green {\n  color: rgb(153, 255, 0);\n}\n.description {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  height: fit-content;\n}\n.red {\n  color: red;\n}\n\n.message {\n  font-size: 0.8rem;\n}\n.small {\n  font-size: 0.9rem;\n}\n\n\n@keyframes slidein {\n  from {\n    margin-left: 100%;\n    width: 300%;\n  }\n\n  to {\n    margin-left: 0%;\n    width: 100%;\n  }\n}\n\n.errorMessage{\n  display: flex;\n  align-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
